import { useStoreActions } from '~/contexts';
import { useMutationState } from '../useMutationState';
export const useRejectNotificationRewrite = ()=>{
    const { api } = useStoreActions();
    const { mutateAsync, isPending } = useMutationState({
        mutationFn: async (conversationId)=>api.notificationRewrite.rejectRewrite(conversationId),
        withPageLoader: false
    });
    return {
        rejectNotificationRewrite: mutateAsync,
        isLoading: isPending
    };
};
